module.exports = __webpack_public_path__ + "static/img/userPhoto.267cacfe.png";